import { afterEach, describe, expect, it } from '@jest/globals';
import { createTempDir, removeTempDir } from '@ms-cloudpack/test-utilities';
import fs from 'fs';
import { dedent } from 'ts-dedent';
import { writeAppConfig } from './writeAppConfig.js';
import { getConfigPath } from '../getConfigPath.js';

describe('writeAppConfig', () => {
  let testPath: string;

  function readConfigText() {
    return fs.readFileSync(getConfigPath(testPath).defaultAppConfigPath, 'utf8');
  }

  afterEach(async () => {
    await removeTempDir(testPath);
  });

  it('writes a new config file', async () => {
    testPath = createTempDir();

    await writeAppConfig(
      {
        server: { port: 8080 },
        features: { syncBundles: true },
      },
      testPath,
    );

    expect(readConfigText()).toMatchInlineSnapshot(`
      "{
        "$schema": "https://unpkg.com/@ms-cloudpack/cli/schema/AppConfig.json",
        "server": {
          "port": 8080
        },
        "features": {
          "syncBundles": true
        }
      }
      "
    `);
  });

  it('updates an existing config file', async () => {
    testPath = createTempDir();
    const config =
      dedent`
      {
        "server": {
          "port": 8080 // comment about this config
        },
        "packageSettings": [
          // very interesting comment
          { "match": { "name": "foo" }, "exports": { ".": "./foo.js" } }
        ]
      }` + '\n'; // ensure trailing newline which would usually be present
    fs.writeFileSync(getConfigPath(testPath).defaultAppConfigPath, config, 'utf8');

    await writeAppConfig(
      {
        server: { port: 8080 },
        packageSettings: [{ match: { name: 'foo' }, exports: { '.': './bar.js' } }],
        features: { syncBundles: true },
      },
      testPath,
    );

    const newConfig = readConfigText();
    expect(newConfig).toContain('// comment about this config');
    expect(newConfig).toContain('// very interesting comment');
    expect(newConfig).toMatchInlineSnapshot(`
      "{
        "server": {
          "port": 8080 // comment about this config
        },
        "packageSettings": [
          // very interesting comment
          { "match": { "name": "foo" }, "exports": { ".": "./bar.js" } }
        ],
        "$schema": "https://unpkg.com/@ms-cloudpack/cli/schema/AppConfig.json",
        "features": {
          "syncBundles": true
        }
      }
      "
    `);
  });
});
